<template>
  <section class="article-back-module-component">
    <div class="rr-container">
      <button
        type="button"
        aria-label="Go back to the previous page"
        @click="goBack">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          aria-hidden="true">
          <g clip-path="url(#article-back-arrow-clip)">
            <path
              d="M10 0.843751L10 1.28125L6.35514 4.9375C4.29907 7 3.52025 7.4375 3.30218 7.6875C3.14642 7.84375 3.14642 7.9375 3.17757 8.0625C3.20872 8.1875 3.33333 8.25 3.52025 8.25C3.89408 8.25 5.01558 8.0625 7.6324 8.0625L19.6885 8.0625L20 8.375L20 9.65625L19.6885 9.96875L7.60125 9.96875C4.98443 9.96875 3.86293 9.78125 3.4891 9.78125C3.30218 9.78125 3.17757 9.84375 3.14642 9.96875C3.11527 10.0938 3.11527 10.1875 3.27103 10.3438C3.4891 10.5625 4.26791 11.0313 6.32399 13.0938L9.96885 16.75L9.96885 17.1875L9.12773 18.0312L8.69159 18.0312L8.14125e-07 9.3125L7.64949e-07 8.75L8.69159 9.88613e-07L9.12773 9.50484e-07L9.96885 0.843751L10 0.843751Z"
              fill="#1E6B5C" />
          </g>
          <defs>
            <clipPath id="article-back-arrow-clip">
              <rect
                width="18"
                height="20"
                fill="white"
                transform="translate(20) rotate(90)" />
            </clipPath>
          </defs>
        </svg>
        <span>Back</span>
      </button>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

const goBack = () => {
  router.back()
}
</script>

<style lang="scss" scoped>
.article-back-module-component {
  @apply bg-white pb-6 lg:pb-0;

  .rr-container {
    button {
      @apply inline-flex cursor-pointer items-center gap-3 border-0 bg-transparent p-0;

      span {
        @apply text-[13px] leading-[1.2] text-balanced underline;
      }
    }
  }
}
</style>
